// extracted by mini-css-extract-plugin
module.exports = {"iconcolor":"var(--foreground-idisabled)","breadcrumbs":"Breadcrumbs_breadcrumbs__xxwzp","main":"Breadcrumbs_main__pU1AI","inner":"Breadcrumbs_inner__TQpml"};